"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodeGenerator = function () {
  function CodeGenerator(_a) {
    var _b = (_a === void 0 ? {} : _a).tab,
        tab = _b === void 0 ? '\t' : _b;
    this.tab = tab;
  }

  CodeGenerator.prototype.generateImport = function (_a) {
    var defaultName = _a.defaultName,
        nonDefaults = _a.nonDefaults,
        namespace = _a.namespace,
        moduleId = _a.moduleId;
    var toImport = [];

    if (defaultName) {
      toImport.push(defaultName);
    }

    if (namespace) {
      toImport.push("* as " + namespace);
    }

    if (nonDefaults) {
      toImport.push("{ " + nonDefaults.join(', ') + " }");
    }

    return "import " + toImport.join(', ') + " from '" + moduleId + "';";
  };

  CodeGenerator.prototype.generateExport = function (_a) {
    var _this = this;

    var defaultExport = _a.defaultExport;
    return ['export default (', defaultExport.split('\n').map(function (x) {
      return _this.tab + x;
    }).join('\n'), ')'].join('\n');
  };

  CodeGenerator.prototype.generateModule = function (_a) {
    var imports = _a.imports,
        defaultExport = _a.defaultExport;
    var textImports = imports.map(this.generateImport);
    return __spreadArrays(textImports, ['', this.generateExport({
      defaultExport: defaultExport
    })]).join('\n');
  };

  return CodeGenerator;
}();

exports.CodeGenerator = CodeGenerator;